"use client";

import React, { useEffect, useState } from "react";
import useWindowSize from "@/lib/hooks/useWindowSize";

import Website from "@/common/constants/webstite";
import { StoryCollectionJson } from "@/types/StoryCollection.type";

import Slider from "@/components/Slider";
import Image from "@/components/ui/Image";
import LinkElement from "@/components/LinkElement";
import TextDateTime from "@/components/TextDateTime";
import { ChevronLeftIcon, ChevronRightIcon } from "@/components/icons";
import ImageConstant from "@/common/constants/image";
import { useAppSelector } from "@/redux/hook";
import ImageV2 from "@/components/ui/ImageV2";

export default async function NBannerProduct({
	data,
}: {
	data: StoryCollectionJson[];
}) {
	const itemRender = (item: StoryCollectionJson) => {
		// const windowSize = useWindowSize();
		const device = useAppSelector((state) => state.ShopReducer.device);

		const bannerDesktop =
			item?.banner_desktop?.url || item?.images[0]?.url || "";
		const bannerMobile =
			item?.banner_mobile?.url || item?.images[0]?.url || "";
		const imageUrl = device === "desktop" ? bannerDesktop : bannerMobile;

		return (
			<LinkElement
				href={`${
					item?.handle ? `${Website.LINK.PAGE.BLOG}/${item?.handle}` : ""
				}`}>
				<section className="hidden md:flex relative gap-[40px] w-fit">
					<ImageV2
						alt="img"
						width={1440}
						height={520}
						sizes="(max-width:1441px) 908px , 1440px"
						src={bannerDesktop}
						className="object-cover lg:max-w-[908px] max-w-full h-[520px]"
						placeholder={"blur"}
						blurDataURL={ImageConstant.BlurDataURL}
					/>
					<div className="flex-[382px] max-w-[382px] flex-shrink-0 h-full flex justify-center items-center my-auto text-left">
						<div className={`flex flex-col justify-center h-full`}>
							<h3 className="text-4xl font-bold leading-[36px] uppercase line-clamp-2">
								{item.title}
							</h3>
							<p
								className="leading-[1.3] mt-4 mb-6 line-clamp-4"
								dangerouslySetInnerHTML={{ __html: item.description }}></p>
							<TextDateTime
								ts={item.date_published}
								className="text-gray-400"
							/>
						</div>
					</div>
				</section>
				<section className="block md:hidden section_container px-4">
					<Image
						alt="img"
						width={800}
						height={365}
						src={bannerMobile}
						className="object-cover object-center w-full h-[365px]"
						placeholder={"blur"}
						blurDataURL={ImageConstant.BlurDataURL}
					/>
					<h3 className="text-2xl font-semibold uppercase mt-4 mb-2 line-clamp-2">
						{item.title}
					</h3>
					<p
						className="line-clamp-3 mb-4"
						dangerouslySetInnerHTML={{ __html: item.description }}></p>
					<TextDateTime
						ts={item.date_published}
						className="text-sm text-gray-400"
					/>
				</section>
			</LinkElement>
		);
	};

	return (
		<div className="w-full max-w-[1440px] mx-auto" id="bannerNMagazineProduct">
			{data.length > 0 && (
				<Slider
					dataSource={data}
					initialSlide={1}
					isloading={false}
					itemRender={itemRender}
					navigation={true}
					speed={500}
					loop={true}
					pagination={{ clickable: true }}
					autoplay={false}
					slidesPerGroup={1}
					slidesPerView={1}
					allowSlideNext={true}
					allowSlidePrev={true}
					freeMode={false}
					allowTouchMove={true}
					centeredSlidesDesktop={false}
					centeredSlidesMobile={true}
					classButtonSlide="hidden md:block"
					iconButtonPrev={
						<ChevronLeftIcon className="w-10 h-10 min-w-10 text-white" />
					}
					iconButtonNext={
						<ChevronRightIcon className="w-10 h-10 min-w-10 text-white" />
					}
					styleButton_prev={{
						left: "-2px ",
						zIndex: "100 ",
					}}
					styleButton_next={{
						right: "calc(36% + 4px)",
						zIndex: "100",
					}}
					responsive={{
						xxs: { slidesPerView: 1, spaceBetween: 0 },
						xs: { slidesPerView: 1, spaceBetween: 0 },
						sm: { slidesPerView: 1, spaceBetween: 0 },
						md: { slidesPerView: 1, spaceBetween: 0 },
						lg: { slidesPerView: 1, spaceBetween: 0 },
						xl: { slidesPerView: 1, spaceBetween: 0 },
					}}
				/>
			)}
		</div>
	);
}
